import classNames from "classnames";
import {
  websiteBuilderGenerateTableDesignStyles,
} from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderTable";
import React from "react";
import { useTableBuilderContext } from "../TableBuilderContext";
import { ACCEPTED_TABLE_BUILDER_DRAG_ITEMS, TableBuilderRowView, TTableBuilderDragItem } from "./TableBuilderRowView";
import { useDrop } from "react-dnd";

export function TableBuilderTableView() {
  const { dragLayerContext, operations, tableNode, tableRef } = useTableBuilderContext();

  const settings = tableNode.container.settings;
  const designStyles = websiteBuilderGenerateTableDesignStyles();

  const [, drop] = useDrop<TTableBuilderDragItem, unknown, unknown>(
    () => ({
      accept: ACCEPTED_TABLE_BUILDER_DRAG_ITEMS,
      drop: () => {
        if (dragLayerContext.type === "column-active") {
          operations.moveColumn();
        } else if (dragLayerContext.type === "row-active") {
          operations.moveRow();
        }
      },
    }),
    [dragLayerContext, operations.moveColumn, operations.moveRow],
  );

  return (
    <div
      ref={drop}
      className={classNames(designStyles.containerClassName, "table-builder")}
    >
      <table
        ref={tableRef}
        className={designStyles.className}
      >
        <thead>
          <TableBuilderRowView row={settings.head.row} />
        </thead>
        <tbody>
          {settings.body.rows.map(row => {
            return (
              <TableBuilderRowView key={row.id} row={row} />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}